import {FormControl, Typography} from "@mui/material"
import {useEffect, useState} from "react"
import {ResponsiveRow} from "../../../constants/layout.constants"
import LineChartsCard from "../../charts/LineChartCard"
import "dayjs/locale/en-gb"
import {getExpensesByVendor} from "../../../services/dashboard.service"
import dayjs from "dayjs"
import {YearPickerInput} from "../../inputs/datePickerInput"
import {useSelector} from "react-redux";

/**
 *
 *
 * REQUIRED PROPS
 *
 * customHeight: string
 * customWidth: string
 * data: {
 *    vendor1: []
 *    vendor2: []
 *  }
 *
 *
 */

export default function ExpensesByVendor({customHeight, customWidth}) {
    const [vendorExpenseData, setVendorExpenseData] = useState([])
    const [year, setYear] = useState(new Date())
    const [loading, setLoading] = useState(false)
    const user = useSelector((state) => state.auth.user);
    useEffect(() => {
        setLoading(true)
        getExpensesByVendor(year.getFullYear())
            .then((response) => {
                if (response && response.data) {
                    setVendorExpenseData(response.data)
                }
            })
            .finally(() => {
                setLoading(false)
            })
        return () => {
            setVendorExpenseData([])
        }
    }, [year, user.proxyFacility])

    return (
        <ResponsiveRow
            sx={{
                flexDirection: "column",
                flexWrap: "nowrap",

                height: {xs: "100%", lg: customHeight},
                width: "100%",

                margin: "10px",

                backgroundColor: "#fff",
                borderRadius: "20px",
            }}
        >
            <ResponsiveRow
                sx={{
                    flexDirection: "row",

                    width: "100%",
                    height: "auto",

                    textAlign: "start",

                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{width: "75%"}} variant="h5">
                    Expenses By Vendor
                </Typography>
                <FormControl sx={{width: {xs: "100%", lg: "25%"}}}>
                    <YearPickerInput
                        labelText="Select Year"
                        componentID="expenseByVendorDate"
                        disableFuture={true}
                        disablePast={false}
                        onSelectDate={(new_value) => {
                            setYear(new Date(new_value))
                        }}
                        value={dayjs(year)}
                    />
                </FormControl>
            </ResponsiveRow>

            <ResponsiveRow
                sx={{
                    height: "80%",
                    width: "100%",

                    flexWrap: "nowrap",
                    flexDirection: "row",

                    alignItem: "center",
                    justifyContent: "center",
                }}
            >
                <LineChartsCard
                    currentlyLoading={loading}
                    labelDataObj={{
                        dataLabels: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                        ],
                        dataset: vendorExpenseData,
                    }}
                />
            </ResponsiveRow>

        </ResponsiveRow>
    )
}
